type SwipeDirection = 'left' | 'right' | 'both'

// На сколько нужно отодвинуть элемент чтобы после отпускания он исчез
const SWIPE_CUTOFF_PX = 75
// На каком расстоянии от изначального элемент станет полностью прозрачным
const SWIPE_OPACITY_THRESHOLD_PX = SWIPE_CUTOFF_PX * 1.25
// При привязывании к курсору элемент начинает перехватывать все клики, что выключает вложенные кнопки. Поэтому привязывание откладывается на столько миллисекунд, чтобы клики по кнопкам успевали корректно обрабатываться до начала свайпа
const SWIPE_CAPTURE_TIMEOUT = 400

const disableElementTransition = (e: HTMLElement) => e.style.setProperty('transition', 'none')
const enableElementTransition = (e: HTMLElement) => e.style.removeProperty('transition')
const adjustElementOpacity = (e: HTMLElement) => {
  const opacityPercentage = 1 - Math.min(1, Math.abs(parseInt(e.style.left) / SWIPE_OPACITY_THRESHOLD_PX))

  e.style.setProperty('opacity', `${opacityPercentage}`)
}

const onSwipe = (elementToMove: HTMLElement, allowedDirection: SwipeDirection) => {
  let lastX = undefined
  return (e: PointerEvent) => {
    const movementX = e.x - lastX
    lastX = e.x
    // Если двигаться можем только влево, максимальное значение вектора перемещения - 0, т.к. он направлен вправо
    const movementMax = allowedDirection === 'left' ? 0 : Infinity
    // Если же двигаться можем только вправо, по той же причине минимум - 0
    const movementMin = allowedDirection === 'right' ? 0 : -Infinity
    const movement = parseInt(elementToMove.style.left || '0') + movementX
    const restrainedMovement = Math.max(movementMin, Math.min(movementMax, movement))

    elementToMove.style.setProperty('left', `${restrainedMovement}px`)
    adjustElementOpacity(elementToMove)
  }
}

const stopSwipe = (el: HTMLElement, eventToRemove: (e: PointerEvent) => void, removeHandler: VoidFunction) =>
  (function cleanup() {
    el.removeEventListener('pointermove', eventToRemove)
    window.removeEventListener('pointerup', cleanup)
    el.removeEventListener('pointercancel', cleanup)

    const swipe = parseInt(el.style.left)
    enableElementTransition(el)

    if (Math.abs(swipe) > SWIPE_CUTOFF_PX) {
      removeHandler()
    } else {
      el.style.setProperty('left', '0')
      el.style.setProperty('opacity', '1')
    }
  })

export const startSwipe = (
  allowedDirection: SwipeDirection,
  removeHandler: VoidFunction,
  e: React.PointerEvent<HTMLElement>,
) => {
  const el = e.currentTarget
  const pointerId = e.pointerId
  const swipeHandler = onSwipe(el, allowedDirection)
  const swipeCleanup = stopSwipe(el, swipeHandler, removeHandler)
  setTimeout(() => {
    // Ошибка бросается если указателя с таким ID нет. Если такое происходит то можно проигнорировать ошибку и начего не делать, на это событие не завязана логика
    try {
      el.setPointerCapture(pointerId)
    } catch {}
  }, SWIPE_CAPTURE_TIMEOUT)
  disableElementTransition(el)

  el.addEventListener('pointermove', swipeHandler)

  window.addEventListener('pointerup', swipeCleanup)
  el.addEventListener('pointercancel', swipeCleanup)
}
